import { render } from "./Project4View.vue?vue&type=template&id=21d02ba8&scoped=true&ts=true"
import script from "./Project4View.vue?vue&type=script&lang=ts"
export * from "./Project4View.vue?vue&type=script&lang=ts"

import "./Project4View.vue?vue&type=style&index=0&id=21d02ba8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d02ba8"]])

export default __exports__